export const pipe =
  (...fns) =>
  (data) =>
    [...fns].reduce((accData, fn) => fn(accData), data);
